import type { FaireProductEntity } from "../../entity_types/product";

export const p_stmngbmv7b: FaireProductEntity = {
  token: "p_stmngbmv7b",
  type: "product",
  name: "Blueberry Donuts 8-Pack (VE, GF, K, No Sugar, Soy-Free)",
  brandToken: "b_d3ssphc04o",
  brandName: "Planet Bake",
  imageUrl:
    "https://cdn.faire.com/fastly/3cb4ce90acbdc2f305f7dd7b763dde627d8d85cda4231bc20e141fbeb9981a23.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8388ac3bae90d0c303dfeff300816b450c6f6c89eec605661b79261c5ec24836.png",
    "https://cdn.faire.com/fastly/efdeec7b5ca4f8cafaa18d4341a559e2d3c9688cc1fdb37fe6b222a75e9e7000.png",
    "https://cdn.faire.com/fastly/69431fe2ea298f4fcb20d126212d13bd427e62cace501db2cf05ddef032dac81.png",
    "https://cdn.faire.com/fastly/8b1d5f7ba3900a57fd465009accaa84869141d61d1285570f787e73e3222ca3f.png",
    "https://cdn.faire.com/fastly/c776867d4bd2a8eabf47a8b6476e33f33a1a5a5400a860e0e01fbafd29b3190d.png",
  ],
  priceDollars: 32.7,
  description:
    "\nBENEFITS?\n\n\n✓ VEGAN ✓ GLUTEN FREE ✓ SUGAR FREE ✓ LOW NET CARB ✓ NON GMO ✓ KOSHER ✓ SOY-FREE ✓ CLEAN INGREDIENTS ✓ WOMEN-OWNED\n\nIndulge in the blissful burst of flavor with our Very Blueberry Donuts. Crafted with real blueberries blended in, each bite is a symphony of sweetness and freshness. Moist and delectable, these donuts elevate the classic blueberry treat to new heights.\n\nExperience the aroma of freshly baked goodness as you open the package, promising a delightful journey for your taste buds. Topped with a luscious, plant-based oat chocolate frosting, adorned with the natural hues of butterfly pea flower powder, every detail of these donuts is crafted to perfection.\n\n\nSavor the richness of real ingredients and the joy of unparalleled taste with our Very Blueberry Donuts. Treat yourself to a moment of pure delight with every bite.\n\n*Nutrition Information can be found in the images!\n\n\nAllergens?\n\nCONTAINS TREE NUTS.\n\n*See packaging for more information!\n\n\n\n\n",
  tags: [],
  msrpDollars: 65.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:09.140Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
